import gql from 'graphql-tag';

export default gql`
mutation updateUserChangelogSeen(
  $email: String!,
  $seenAt: timestamptz!,
) {
  update_users(
    where: {
      email: {_eq: $email}
    },
    _set: {changelog_seen_at: $seenAt}
  ) {
    affected_rows
  }
}
`;
